import React from 'react';
import { achievements } from '../../data/mock';

const AchievementsSection = () => {
  return (
    <div className="window mb-6">
      <div className="window-header">
        <span>🏆 Achievements & Awards 🏆</span>
      </div>
      <div className="window-body">
        <div className="text-center mb-4">
          <div className="inline-block">
            <span className="text-3xl mx-2 animate-pulse">✨</span>
            <span className="text-3xl mx-2 animate-bounce">🌟</span>
            <span className="text-3xl mx-2 animate-pulse">✨</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {achievements.map((achievement) => (
            <div
              key={achievement.id}
              className="bg-gradient-to-br from-yellow-100 to-orange-100 p-4 border-3 border-double border-yellow-600"
            >
              <div className="flex items-start gap-3 mb-2">
                <span className="text-3xl">
                  {achievement.icon === 'trophy' && '🏆'}
                  {achievement.icon === 'award' && '🏅'}
                  {achievement.icon === 'star' && '⭐'}
                  {achievement.icon === 'medal' && '🥇'}
                  {achievement.icon === 'certificate' && '📜'}
                </span>
                <div className="flex-1">
                  <h3 className="font-bold text-sm mb-1 pixel-text" style={{ color: '#ff1493' }}>
                    {achievement.title}
                  </h3>
                  <div className="flex flex-wrap gap-1 mb-2">
                    {achievement.rank && (
                      <span className="bg-white px-2 py-0.5 text-xs font-bold border border-black">
                        Rank: {achievement.rank}
                      </span>
                    )}
                    {achievement.percentile && (
                      <span className="bg-pink-200 px-2 py-0.5 text-xs font-bold border border-pink-400">
                        {achievement.percentile}
                      </span>
                    )}
                  </div>
                  <p className="text-xs">{achievement.description}</p>
                </div>
                <span className="bg-purple-500 text-white px-2 py-1 text-xs font-bold">
                  {achievement.year}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AchievementsSection;
